import EmptyState from "@/components/campaign/analytics/report/shared/emptyState";
import { Button, ButtonText } from "@repo/components/src/ui/button";
import { Link } from "expo-router";
import { Lock } from "lucide-react-native";
import React from "react";

/** Plan gate for both Analytics tabs. Uses the campaign report's `EmptyState`
 *  so every placeholder in the section reads as the same surface. */
const AnalyticsUpsell = React.memo(() => {
  return (
    <EmptyState
      icon={Lock}
      title="Analytics no está en tu plan"
      description="Mejora tu plan para consolidar reportes de varias campañas en uno solo y ver el rendimiento de tus redes conectadas."
      actions={
        <Link asChild href={{ pathname: "/app/(brands)/settings/plan" }}>
          <Button action="brand" variant="solid" rounded="lg">
            <ButtonText>Ir a mi plan</ButtonText>
          </Button>
        </Link>
      }
    />
  );
});

AnalyticsUpsell.displayName = "AnalyticsUpsell";

export default AnalyticsUpsell;
